// removed by extract-text-webpack-plugin
module.exports = {"BuildControl":"BuildControl__BuildControl__3YmJB","Label":"BuildControl__Label__13rVO","Less":"BuildControl__Less__3VsI5","More":"BuildControl__More__3u1cU"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Burger/BuildControls/BuildControl/BuildControl.css
// module id = 47
// module chunks = 0